import { AssignmentsFilterType, LotFilterType, PickupPlanningTransportOrdersFilterType, TypeLotFilters } from 'apps/nagel-cal-disposition/src/models/planningPageTypes';
import { DELIVERY_TOUR_POINT_TYPE, PICKUP_TOUR_POINT_TYPE } from '../../utils/tourPointsUtils';

export const PICKUP_PLANNING_CARD_CHIPS = {
    //Uncomment if we want to see the avise chip in cards
    // AVISE: 'hasAvis',
    WEIGHT: 'weight',
    VOLUME_PALLET_SPACES: 'plannedVolumePalletSpaces',
    FLOOR_PALLET_SPACES: 'plannedFloorPalletSpaces',
    DELIVERY_DATE_FROM: 'deliveryDateFrom',
    DELIVERY_DATE_TO: 'deliveryDateTo',
    PLANNED_TIME: 'plannedTime',
    PEOPLE: 'people',
    TRAFFIC_FLOW: 'trafficFlow',
    PARKING: 'parking',
    AMBIENT: 'airconditioner',
    EXECUTION_INTERVAL: 'executionInterval',
    FRESH: 'fresh',
    ULTRA_FRESH: 'ultraFresh',
    DRY: 'dry',
    LIQUID: 'liquid',
    FROZEN : 'frozen',
    FRUITS_AND_VEGETABLES: 'fruitsAndVegetables'
};

export const DRIVE_INSTRUCTION_TOUR_POINT_CHIPS = {
    WEIGHT: 'weight',
    VOLUME_PALLET_SPACES: 'plannedVolumePalletSpaces',
    FLOOR_PALLET_SPACES: 'plannedFloorPalletSpaces',
    DELIVERY_DATE_FROM: 'deliveryDateFrom',
    PLANNED_TIME: 'plannedTime',
    PEOPLE: 'people',
    TRAFFIC_FLOW: 'trafficFlow',
};

export const TRAFFIC_FLOW_DESCRIPTIONS: Record<string, string> = {
    1: $localize`Direct Delivery`,
    2: $localize`Direct from Pick-Up Branch`,
    3: $localize`Direct to Receiving Branch`,
    4: $localize`Consolidation`
};

export const DRIVE_INSTRUCTION_SHIPMENT_CHIPS = {
    WEIGHT: 'weight',
    VOLUME_PALLET_SPACES: 'plannedVolumePalletSpaces',
    FLOOR_PALLET_SPACES: 'plannedFloorPalletSpaces',
    FIXED_DELIVERY_DATE_FROM: 'fixedDeliveryDateFrom',
    FIXED_DELIVERY_TIME_FROM: 'plannedTime',
    TRAFFIC_FLOW: 'trafficFlow',
};

export const TEMPERATURE_CLASSES_ICONS_MAP: {[key: string] : string} = {
    [PICKUP_PLANNING_CARD_CHIPS.FRUITS_AND_VEGETABLES]: 'apple_icon',
    [PICKUP_PLANNING_CARD_CHIPS.DRY]: 'leaf_icon',
    [PICKUP_PLANNING_CARD_CHIPS.FROZEN]: 'snowflake_icon',
    [PICKUP_PLANNING_CARD_CHIPS.LIQUID]: 'drop_icon',
    [PICKUP_PLANNING_CARD_CHIPS.FRESH]: 'strawberry_icon',
    [PICKUP_PLANNING_CARD_CHIPS.ULTRA_FRESH]: 'citrus_icon',
    [PICKUP_PLANNING_CARD_CHIPS.AMBIENT]: 'air_conditioner_icon'
};

export const FILTERS_KEYS_MAP = {
    STOPS: 'stops',
    TOUR_NO: 'tourNo',
    ORIGIN_ZIP_CODE: 'OriginZipCode',
    HAS_PRODUCT_GROUP: 'HasProductGroup',
    DELIVERY_DATE_TO: 'DeliveryDateTo',
    PICKUP_DATE_FROM: 'PickupDateFrom',
    HAS_TRAFFIC_FLOW: 'HasTrafficFlow',
    HAS_VOLUME_PALLET_RANGE: 'HasVolumePalletRange',
    HAS_FLOOR_PALLET_RANGE: 'HasFloorPalletRange',
    TOTAL_WEIGHT: 'TotalWeight'
};

export const TRANSPORT_MODE_VALUE_TO_LABEL_MAP: { [key: number]: string } = {
    10: $localize `Only Data Transfer`,
    20: $localize `Long-Haul`,
    21: $localize `Encounter Traffic`,
    22: $localize `One-Way`,
    23: $localize `Night Shuttle`,
    24: $localize `Tramping Traffic KVN`,
    25: $localize `Other System Traffic`,
    26: $localize `Partial Charter`,
    27: $localize `Self-Pick Up`,
    28: $localize `FTL/LTL (Without Palletization)`,
    30: $localize `Multi Drop`,
    31: $localize `Pick-Up – Drop-Off – Roll-Off (ML)`,
    35: $localize `Add-on Loading`,
    40: $localize `Intermodal Transport`,
    41: $localize `Partial Transport, Carrier Change`,
    50: $localize `Local Transport`,
    60: $localize `Pickup`,
};

export const STATUS_VALUE_TO_LABEL_MAP: { [key: number]: string } = {
    0: $localize `New Transport Order`,
    1: $localize `Missing Carrier, Truck or Shipments`,
    2: $localize `Transport Order Services Generated`,
    3: $localize `Transport Order Freight Calculated`,
    5: $localize `Transport Order Completed (All Shipments Processed)`,
    6: $localize `Transport Order Invoiced`,
    7: $localize `Transport Order Released for Invoice (Re-distributed)`,
    9: $localize `Transport Order Ready for Processing (Shipments Added)`,
    12: $localize `Shipments Missing`,
    13: $localize `Transport Order Prepared for Transfer to DFV (Delivery Fulfillment Verification)`,
    15: $localize `Transport Order Taken Over from Dispatch to Handling (Intermediate State, Without Correspondence in TA)`,
    16: $localize `Transport Order Currently Taken Over from Dispatch to Handling (Intermediate State, Without Correspondence in TA)`,
    18: $localize `Order Cancellation Sent to MDE`,
    32: $localize `Error: Shipments Not Fully Transferred to DFV During Processing`,
    99: $localize `Status Not Defined`,
    630: $localize `Transport Order Accepted by MDE`,
    631: $localize `Transport Order Rejected by MDE`,
    632: $localize `Transport Order Sent to MDE`,
    633: $localize `Transport Order Transferred to Central MDE System`,
    635: $localize `Order Cancellation Sent to MDE`,
    637: $localize `Transport Order Activated for MDE`,
    638: $localize `Order Cancellation Activated for MDE`
};

export const ASSIGNMENTS_FILTER_VALUES_MAP: AssignmentsFilterType = {
    'stops': {
        lessThanFive: false,
        fiveToTen: false,
        tenToFifteen: false,
        fifteenToTwenty: false,
        twentyToThirty: false,
        moreThanThirty: false
    },
    'tourNo': { from: undefined, to: undefined },
    'OriginZipCode': '',
    'HasProductGroup': {
        [PICKUP_PLANNING_CARD_CHIPS.FRUITS_AND_VEGETABLES]: false,
        [PICKUP_PLANNING_CARD_CHIPS.DRY]: false,
        [PICKUP_PLANNING_CARD_CHIPS.FROZEN]: false,
        [PICKUP_PLANNING_CARD_CHIPS.LIQUID]: false,
        [PICKUP_PLANNING_CARD_CHIPS.FRESH]: false,
        [PICKUP_PLANNING_CARD_CHIPS.ULTRA_FRESH]: false,
        [PICKUP_PLANNING_CARD_CHIPS.AMBIENT]: false
    },
    'DeliveryDateTo': null,
    'PickupDateFrom': null,
    'HasTrafficFlow': {
        1: false,
        2: false,
        3: false,
        4: false
    },
    'HasVolumePalletRange': {
        lessThanFive: false,
        fiveToTen: false,
        tenToFifteen: false,
        fifteenToTwenty: false,
        twentyToThirty: false,
        moreThanThirty: false
    },
    'HasFloorPalletRange': {
        lessThanFive: false,
        fiveToTen: false,
        tenToFifteen: false,
        fifteenToTwenty: false,
        twentyToThirty: false,
        moreThanThirty: false
    },
    'TotalWeight':  { from: undefined, to: undefined }
};

export const LOTS_FILTER_VALUES_MAP: LotFilterType = {
    'OriginZipCode': '',
    'HasProductGroup': {
        [PICKUP_PLANNING_CARD_CHIPS.FRUITS_AND_VEGETABLES]: false,
        [PICKUP_PLANNING_CARD_CHIPS.DRY]: false,
        [PICKUP_PLANNING_CARD_CHIPS.FROZEN]: false,
        [PICKUP_PLANNING_CARD_CHIPS.LIQUID]: false,
        [PICKUP_PLANNING_CARD_CHIPS.FRESH]: false,
        [PICKUP_PLANNING_CARD_CHIPS.ULTRA_FRESH]: false,
        [PICKUP_PLANNING_CARD_CHIPS.AMBIENT]: false
    },
    'DeliveryDateTo': null,
    'PickupDateFrom': null,
    'HasTrafficFlow': {
        1: false,
        2: false,
        3: false,
        4: false
    },
    'HasVolumePalletRange': {
        lessThanFive: false,
        fiveToTen: false,
        tenToFifteen: false,
        fifteenToTwenty: false,
        twentyToThirty: false,
        moreThanThirty: false
    },
    'HasFloorPalletRange': {
        lessThanFive: false,
        fiveToTen: false,
        tenToFifteen: false,
        fifteenToTwenty: false,
        twentyToThirty: false,
        moreThanThirty: false
    },
    'TotalWeight':  { from: undefined, to: undefined }
};

export const TYPE_LOT_FILTERS_VALUES_MAP: TypeLotFilters = {
    OneOfLegTypes: []
};

export const HAS_LEG_TYPE_COMBINATION = 'OneOfLegTypes';

export const DEFAULT_LOT_RECORDS_PER_PAGE = 10;
export const DEFAULT_DATA_VALUE = { totalRecordsCount: 0, records: [], pinned: [] };
export const DEBOUNCE_TIME = 1000;

export const PICKUP_TRANSPORT_ORDERS_FILTER_VALUES_MAP: PickupPlanningTransportOrdersFilterType = {
    'stops': {
        lessThanFive: false,
        fiveToTen: false,
        tenToFifteen: false,
        fifteenToTwenty: false,
        twentyToThirty: false,
        moreThanThirty: false
    },
    'tourNo': { from: undefined, to: undefined },
    'contractorPostalCode': '',
    'HasProductGroup': {
        [PICKUP_PLANNING_CARD_CHIPS.FRUITS_AND_VEGETABLES]: false,
        [PICKUP_PLANNING_CARD_CHIPS.DRY]: false,
        [PICKUP_PLANNING_CARD_CHIPS.FROZEN]: false,
        [PICKUP_PLANNING_CARD_CHIPS.LIQUID]: false,
        [PICKUP_PLANNING_CARD_CHIPS.FRESH]: false,
        [PICKUP_PLANNING_CARD_CHIPS.ULTRA_FRESH]: false,
        [PICKUP_PLANNING_CARD_CHIPS.AMBIENT]: false
    },
    'plannedDepartureTime': null,
    'plannedVolumePalletSpaces': {
        lessThanFive: false,
        fiveToTen: false,
        tenToFifteen: false,
        fifteenToTwenty: false,
        twentyToThirty: false,
        moreThanThirty: false
    },
    'plannedFloorPalletSpaces': {
        lessThanFive: false,
        fiveToTen: false,
        tenToFifteen: false,
        fifteenToTwenty: false,
        twentyToThirty: false,
        moreThanThirty: false
    },
    'weight':  { from: undefined, to: undefined },
    'transportOrderNumber': '',
    'truckLicensePlate': '',
    'contractorName1': [],
    'status': Object.keys(STATUS_VALUE_TO_LABEL_MAP).reduce((acc, key) => {
        return {
            ...acc,
            [key]: false
        };
    }, {}),
    'transportMode': Object.keys(TRANSPORT_MODE_VALUE_TO_LABEL_MAP).reduce((acc, key) => {
        return {
            ...acc,
            [key]: false
        };
    }, {})
};

export const DEFAULT_TRANSPORT_ORDERS_PAGE_SIZE = 6;


export const EXPANDABLE_TOUR_POINT_TYPES = [
    PICKUP_TOUR_POINT_TYPE,
    DELIVERY_TOUR_POINT_TYPE
];

export const DEFAULT_TRANSPORT_CARD_VALUE = '--:-- ----';

export const TRAFFIC_MODE_LEG_TYPES: Record<string, string[]> = {
    '1': ['HL'],
    '2': ['VL', 'HL'],
    '3': ['HL', 'NL'],
    '4': ['VL', 'HL', 'NL'],
};

/* eslint-disable no-magic-numbers */
export enum TransportOrderStatus {
    Completed = 5
}

export const INVOICED_TRANSPORT_ORDER_STATUS = 6;
export const RELEASED_FOR_INVIOICING_TRANSPORT_ORDER_STATUS = 7;
export const DISABLED_TRANSPORT_ORDER_STATUSES = [
    INVOICED_TRANSPORT_ORDER_STATUS,
    RELEASED_FOR_INVIOICING_TRANSPORT_ORDER_STATUS
];